import { SheetActions, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { formatDistance } from "date-fns";
import { CardDescription } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { StipendMiniCard } from "../components/StipendMiniCard";
import { ProgressBar } from "../components/ProgressBar";
import { formatLongDate } from "@common/components/utils";
import { StipendExpense, StipendWalletResponse } from "@common/utils/graphql";
import { useState } from "react";
import { CreateStipendSheetContent } from "./CreateStipendSheetContent";
import { Body } from "@hypercard/web-components";

interface Props {
  stipend: StipendWalletResponse;
  onSubmitClaim: () => void;
}

export const ViewStipendDetailsSheetContent = ({
  stipend,
  onSubmitClaim,
}: Props) => {
  const [viewExpenseId, setViewExpenseId] = useState<string | undefined>();

  let viewExpense = null;

  if (Array.isArray(stipend?.expenses)) {
    viewExpense = stipend.expenses.find(
      (expense) => expense.stipendExpenseId === viewExpenseId,
    );
  }

  if (viewExpense) {
    return (
      <CreateStipendSheetContent
        expense={viewExpense as StipendExpense}
        onCloseView={() => setViewExpenseId(undefined)}
      />
    );
  }
  const header = (
    <SheetHeader>
      <SheetTitle>
        <div>{stipend?.stipendDetail?.name}</div>
      </SheetTitle>
      <Body size="md" weight="regular" className="text-white/70">
        {stipend?.stipendDetail?.cycleEndDate
          ? "Renews " +
            formatDistance(stipend?.stipendDetail?.cycleEndDate, new Date(), {
              addSuffix: true,
            })
          : "No renewal"}
      </Body>
      <Body size="md" weight="regular" className="mt-6 text-white/70">
        {stipend?.stipendDetail.longDetails || "No details"}
      </Body>
      <CardDescription className="mt-8 flex justify-between border-b p-0 pb-6">
        <ProgressBar stipend={stipend} />
      </CardDescription>
    </SheetHeader>
  );

  const metadata = (
    <div className="mx-sheet-gap mb-8 flex flex-col gap-3">
      <Label>Expiry Date</Label>
      <Body size="lg" weight="regular">
        {stipend?.expiresAt
          ? "Expires on " + formatLongDate(stipend?.expiresAt)
          : "No expiry"}
      </Body>
    </div>
  );

  const stipendsPreview = (
    <div className="flex flex-grow flex-col gap-3 overflow-auto px-sheet-gap pb-4 scrollbar-thin">
      <Label>Expenses</Label>
      {stipend?.expenses.map((expense) => (
        <StipendMiniCard
          expense={expense as StipendExpense}
          onView={setViewExpenseId}
          key={expense.stipendExpenseId}
        />
      ))}
      {stipend?.expenses.length === 0 && <p>No recorded expenses</p>}
    </div>
  );

  const actions = (
    <SheetActions className="static">
      <Button className="w-full" type="submit" onClick={onSubmitClaim}>
        Submit Claim
      </Button>
    </SheetActions>
  );

  return (
    <>
      {header}
      {metadata}
      {stipendsPreview}
      {actions}
    </>
  );
};
